import React, {createContext, useEffect, useState} from 'react'
import {fetchRelationStore} from "../../../api/clubPlatform"

/**
 *  @typedef  MeiTuanPlatformType
 * @property {object} platform
 * @property {number} platform.clubId
 * @property {number} platform.order
 * @property {string} platform.name
 * @property {number} platform.id
 * @property {boolean} platform.isConsumable
 * @property {boolean} platform.isEnabled
 * @property {string} platform.createTime
 * @property {string} platform.updateTime
 * @property {object} value
 * @property {object} value.merchant
 * @property {string} value.merchant.platformMerchantId
 * @property {string} value.merchant.name
 * @property {number} value.merchant.id
 * @property {string} value.merchant.createTime
 * @property {string} value.merchant.updateTime
 * @property {object} value.shop
 * @property {number} value.shop.merchantId
 * @property {string} value.shop.platformShopId
 * @property {string} value.shop.name
 * @property {string} value.shop.createTime
 * @property {string} value.shop.updateTime
 * @property {number} value.shop.id
 */


const initialState = {

    /**
     * @type {{isloading: boolean, error: null, relationStore: MeiTuanPlatformType[]}}
     */
    platformListState: {
        isLoading: false,
        error: null,
        relationStore: []
    },
    getRelationStore: () => {
    }
}


const ClubPlatformContext = createContext(initialState)

export const ClubPlatformProvider = ({children}) => {
    const [platformListState, setPlatformListState] = useState(initialState.platformListState)


    const getRelationStore = async () => {
        setPlatformListState(prevState => ({
            ...prevState,
            isLoading: true
        }))

        try {
            const {status, data, detail} = await fetchRelationStore('', false)
            if (status !== 1) {
                setPlatformListState(prevState => ({
                    ...prevState,
                    error: detail
                }))
                return
            }
            setPlatformListState(prevState => ({
                ...prevState,
                relationStore: data
            }))
        } catch (err) {
            setPlatformListState(prevState => ({
                ...prevState,
                error: '获取平台商户失败'
            }))
            console.log(err.message)
        } finally {
            setPlatformListState(prevState => ({
                ...prevState,
                isLoading: false
            }))
        }
    }

    useEffect(() => {
        getRelationStore()
    }, [])

    const value = {
        platformListState,
        getRelationStore
    }

    return (
        <ClubPlatformContext.Provider value={value}>
            {children}
        </ClubPlatformContext.Provider>
    )
}

export const useClubPlatformContext = () => {
    const context = React.useContext(ClubPlatformContext)
    if (!context) {
        throw new Error('useClubPlatformContext must be used within a ClubPlatformProvider')
    }
    return context
}




// WEBPACK FOOTER //
// ./src/containers/ClubPlatform/store/useClubPlatformContext.js